import { render, staticRenderFns } from "./EmailExpandedFileReader.vue?vue&type=template&id=11b1bbc6"
import script from "./EmailExpandedFileReader.vue?vue&type=script&lang=js"
export * from "./EmailExpandedFileReader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports